import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from '@angular/common';
import {MatIcon} from "@angular/material/icon";
import {Doctor, Patient} from "@interfaces/doctors";
import {MatProgressBar} from "@angular/material/progress-bar";
import {DoctorsService} from "@services/doctors/doctors.service";

@Component({
  selector: 'app-patient-detail',
  imports: [
    MatIcon,
    MatProgressBar
  ],
  templateUrl: './patient-detail.component.html',
  standalone: true,
  styleUrl: './patient-detail.component.scss'
})
export class PatientDetailComponent {
  patient?: Patient;
  doctors?: Doctor[];
  doctor?: Doctor;

  constructor(
    private doctorsService: DoctorsService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.doctorsService.doctorsListObservable$
      .subscribe((doctors: any) => {
        this.doctors = doctors;
        this.route.paramMap.subscribe(params => {
          const doctorId = params.get('doctorId') ?? '';
          const patientId = params.get('patientId') ?? '';
          this.loadPatient(doctorId, patientId);
        });
      });
  }

  loadPatient(doctorId: string, patientId: string) {
    if (doctorId && this.doctors && patientId) {
      this.doctors.forEach((doctor: Doctor) => {
        if (doctor.id === doctorId) {
          this.doctor = doctor;
          doctor.patients.forEach((patient: Patient) => {
            if (patient.id === patientId) {
              this.patient = patient;
              return;
            }
          });
        }
      });
    }
  }

  goBack() {
    this.location.back();
  }

  openReports() {
    this.router.navigate(['reports'], {relativeTo: this.route});
  }

  openKits() {
    this.router.navigate(['kits'], {relativeTo: this.route});
  }
}
